import type { PropsWithChildren } from 'react';
import { useRef } from 'react';
import { setUserId } from '@snowplow/browser-tracker';

import { initSnowplowTracker } from 'Services/snowplow';
import type { User } from 'Types/user';
import { isSSR } from 'Utilities/helpers';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

interface SnowplowInitialiserProps {
	user?: User;
}

export const SnowplowInitialiser: React.FC<PropsWithChildren<SnowplowInitialiserProps>> = ({ children, user }) => {
	const userId = useRef<Nullable<User['id']> | undefined>(null);
	const isSnowplowMiniRedirect = useFeatureToggle(FEATURES.snowplowMiniRedirect) as boolean;

	if (isSSR()) {
		return <>{children}</>;
	}

	if (!window.snowplowMW) {
		window.snowplowMW = initSnowplowTracker({ isSnowplowMiniRedirect });
	}

	if (userId.current !== user?.id) {
		setUserId(user?.id ? `${user?.id}` : undefined);
		userId.current = user?.id;
	}

	return <>{children}</>;
};
